import React from "react"
import { Modal } from "react-bootstrap"
import Style from "./EmbeddedAssetStyle.module.styl"

const EmbeddedAssetModal = ({
  embeddedAssetModal,
  toggleEmbeddedAssetModal,
  embeddedImage,
}) => {
  return (
    <Modal
      className="embedded-modal"
      show={embeddedAssetModal}
      onHide={toggleEmbeddedAssetModal}
    >
      <Modal.Header closeButton />
      <Modal.Body>
        <img
          className={Style.image}
          src={embeddedImage}
          alt="embedded-blog-asset"
        />
      </Modal.Body>
    </Modal>
  )
}

export default EmbeddedAssetModal
